import { Box, Button, CloseButton, Flex, Input, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import Axios from "../../../../services/axios";
import Select from "react-select";

export default function SelectedProducts({ defaultSelectedProducts, setReceivedProducts, isViewOnly }) {
  const [products, setProducts] = useState([]);
  const [isLoadingProduct, setIsLoadingProduct] = useState(false);
  const fetchProducts = async () => {
    try {
      setIsLoadingProduct(true);
      const { data } = await Axios({
        url: "/product/list?sort=name,asc",
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });
      setProducts(data?.data?.products?.map(product => ({ ...product, label: product.name, value: product.id })) || []);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingProduct(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (!!products.length && !!defaultSelectedProducts?.length) {
      setSelectedProducts(
        defaultSelectedProducts?.reduce?.((transformed, currentProduct) => {
          const productInDB = products?.find?.(productDB => productDB.id === currentProduct.productId);
          if (!!productInDB) {
            transformed.push({
              ...productInDB,
              ...currentProduct,
              ...!!productInDB?.productVariants?.length && {
                variantId: currentProduct.variantId || currentProduct.productVariantId,
                variantImage: productInDB?.productVariants?.find?.(variant => variant.id === (currentProduct.variantId || currentProduct.productVariantId))?.variantThumbnail,
                variantName: productInDB?.productVariants?.find?.(variant => variant.id === (currentProduct.variantId || currentProduct.productVariantId))?.name,
              },
              value: currentProduct.variantId || currentProduct.productVariantId || productInDB.id,
              qty: isViewOnly ? currentProduct.qty : 0,
            });
          }
          return transformed;
        }, []) || []
      );
    }
  }, [products, defaultSelectedProducts]);

  const [selectedProducts, setSelectedProducts] = useState([]);

  function getCurrentProductValue(selectedProduct) {
    const foundProduct = products.find(product => selectedProduct.id === product.id);
    return foundProduct || {
      label: "",
      value: "",
      variantId: null,
      variantImage: null,
      variantName: null,
      qty: 0
    };
  }

  function getVariantValue(selectedProduct) {
    const selectedVariant = selectedProduct.productVariants.find(variant => variant.name === selectedProduct.variantName);
    return !!selectedVariant ? { ...selectedVariant, label: selectedVariant.name, value: selectedVariant.id } : null;
  }

  const variantRefs = useRef([]);
  const clearVariant = (index) => {
    setTimeout(() => {
      variantRefs?.current?.[index]?.clearValue?.();
    }, 400);
  };

  function removeProduct(index) {
    setSelectedProducts(prevProducts => {
      const currentProducts = [...prevProducts];
      currentProducts.splice(index, 1);
      return currentProducts;
    });
  }

  useEffect(() => {
    setReceivedProducts(selectedProducts);
  }, [selectedProducts]);

  return (
    <>
      {
        !!selectedProducts.length && (
          <Flex>
            <Text width={isViewOnly ? "calc(50% - 31px)" : "calc(50% - 47px)"} paddingRight="18px" fontWeight={"700"} className="action-content">
              Product:
            </Text>
            <Text width={isViewOnly ? "calc(50% - 31px)" : "calc(50% - 47px)"} paddingRight="18px" fontWeight={"700"} className="action-content">
              Variant:
            </Text>
            <Text width={isViewOnly ? "62px" : "94px"} fontWeight={"700"} className="action-content">
              Qty
            </Text>
          </Flex>
        )
      }
      {
        selectedProducts?.map?.((product, index) => (
          <Flex key={index} alignItems="center" marginBottom="12px">
            <Box width={isViewOnly ? "calc(50% - 31px)" : "calc(50% - 47px)"} paddingRight="18px">
              <Select
                className="basic-single"
                classNamePrefix="select"
                value={getCurrentProductValue(product)}
                isClearable={false}
                isSearchable
                isDisabled={isViewOnly}
                name={`selectedProduct${index}`}
                options={products}
                placeholder="Select product"
                components={{
                  IndicatorSeparator: () => null
                }}
                styles={{
                  control: (baseStyles) => {
                    return {
                      ...baseStyles,
                      opacity: 1,
                      borderColor: "inherit !important",
                    };
                  },
                  menu: (baseStyles) => {
                    return {
                      ...baseStyles,
                      minWidth: "280px"
                    };
                  },
                }}
                onChange={(event) => {
                  if (!!event?.productVariants.length) {
                    clearVariant(index);
                  }
                  setSelectedProducts(prevProducts => {
                    const currentProducts = [...prevProducts];
                    currentProducts[index] = {
                      ...event,
                      qty: currentProducts[index].qty || 0,
                      // reset variant
                      variantId: null,
                      variantImage: null,
                      variantName: null
                    };
                    return currentProducts;
                  });
                }}
              />
            </Box>
            <Box width={isViewOnly ? "calc(50% - 31px)" : "calc(50% - 47px)"} paddingRight="18px">
              {
                !!product.productVariants?.length && (
                  <Select
                    ref={el => variantRefs.current[index] = el}
                    className="basic-single"
                    classNamePrefix="select"
                    defaultValue={getVariantValue(product)}
                    isClearable={false}
                    isSearchable
                    isDisabled={isViewOnly}
                    name={`selectedProductVariant${index}`}
                    options={product.productVariants.map(variant => ({ ...variant, label: variant.name, value: variant.id }))}
                    placeholder="Select product variant"
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    styles={{
                      control: (baseStyles) => {
                        return {
                          ...baseStyles,
                          opacity: 1,
                          borderColor: "inherit !important",
                        };
                      },
                      menu: (baseStyles) => {
                        return {
                          ...baseStyles,
                          minWidth: "280px"
                        };
                      },
                    }}
                    onChange={(event) => {
                      if (!!event) {
                        setSelectedProducts(prevProducts => {
                          const currentProducts = [...prevProducts];
                          currentProducts[index] = {
                            ...currentProducts[index],
                            variantId: event.id,
                            variantImage: event.variantPickerImage,
                            variantName: event.name
                          };
                          return currentProducts;
                        });
                      }
                    }}
                  />
                )
              }
            </Box>
            <Input width="62px" value={product.qty} isDisabled={isViewOnly} onChange={(event) => {
              setSelectedProducts(prevProducts => {
                const currentProducts = [...prevProducts];
                currentProducts[index] = {
                  ...currentProducts[index],
                  qty: isNaN(+event.target.value) ? currentProducts[index].qty : +event.target.value
                };
                return currentProducts;
              });              
            }} />
            {
              !isViewOnly && (
                <Box width="32px">
                  <CloseButton onClick={() => { removeProduct(index) }} />
                </Box>
              )
            }
          </Flex>
        ))
      }
      {
        !isViewOnly && (
          <Button
            border="1px solid #FE8084"
            backgroundColor="#fff"
            fontSize="12px"
            fontWeight="700"
            color="#FE8084"
            size="xs"
            padding="0 40px"
            isDisabled={isLoadingProduct}
            onClick={() => {
              setSelectedProducts(prevProducts => {
                const currentProducts = [...prevProducts];
                currentProducts.push({
                  label: "",
                  value: "",
                  variantId: null,
                  variantImage: null,
                  variantName: null,
                  qty: 0
                });
                return currentProducts;
              });
            }}
          >
            Add Product
          </Button>
        )
      }
    </>
  );
}